import { MenuItem, Select } from '@mui/material'
import { useProductCategories } from '../../EditQuote/lines/productCategories'
import './CategorySelect.css'

export interface CategorySelectProps {
  value: string
  onChange: (productCategory: string) => void
}

export function CategorySelect({ value, onChange }: CategorySelectProps) {
  // Group categories can't be assigned, so show them as unset
  const categories = useProductCategories()
  const selectable = categories.some(category => category.name === value)
  return (
    <Select
      size="small"
      value={selectable ? value : ''}
      displayEmpty
      onChange={e => onChange(e.target.value)}
      className="category-select"
    >
      <MenuItem value="" disabled>
        Pick a category
      </MenuItem>
      {categories.map(category => (
        <MenuItem key={category.name} value={category.name}>
          {category.name}
        </MenuItem>
      ))}
    </Select>
  )
}
